module.exports = __webpack_public_path__ + "static/Ramesant-daf4d05a4af3c82908c0be02df782a4c.otf";